import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useCurrentOrgContext } from '@/context/CurrentOrgContext'
import { useIsProjectDb } from '@/hooks/useIsProjectDb'
import { ORG_DATABASE_ROUTE, ORG_ROUTE } from '@/shared/constants'

import { LayoutDatabaseDropdown } from './components/LayoutDatabaseDropdown'
import { LayoutTablesDropdown } from './components/LayoutTablesDropdown'

/**
 * New Db Table Layout Header (Left)
 */
export default function DbTableHeaderLeftSection() {
  return (
    <div className='flex-c'>
      <DatabaseLabel />

      <div>/</div>

      <LayoutDatabaseDropdown />

      <div>/</div>

      <LayoutTablesDropdown />
    </div>
  )
}

const DatabaseLabel = () => {
  const { t } = useTranslation()
  const { currentOrg } = useCurrentOrgContext()
  const isProject = useIsProjectDb()

  return !isProject ? (
    <Link
      className='text-light font-normal'
      title={t('Databases')}
      to={`${ORG_ROUTE}/${currentOrg?.id}/${ORG_DATABASE_ROUTE}`}
    >
      {t('Databases')}
    </Link>
  ) : (
    <div>{t('Databases')}</div>
  )
}
